/* DECOREL WALL — Landing page */
(function () {
  'use strict';
  var d = document;

  /* ---------- tracking ---------- */
  function track(name, data) {
    data = data || {};
    var v = d.documentElement.getAttribute('data-lp-v');
    if (v) data.lp_variant = v;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
      window.dataLayer.push(payload);
    } catch (e) {}
  }
  window.lpTrack = track;

  d.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var el = t.closest('[data-lp-track]');
    if (el) track('lp_cta_click', { location: el.getAttribute('data-lp-track'), label: (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 40) });

    var yt = t.closest('[data-lp-yt]');
    if (yt) {
      var id = yt.getAttribute('data-lp-yt');
      var f = d.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
      f.title = yt.getAttribute('aria-label') || 'YouTube';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.setAttribute('allowfullscreen', '');
      yt.parentNode.replaceChild(f, yt);
      track('lp_video_play', { video_id: id });
    }
  });

  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }

  /* ---------- sticky CTA ---------- */
  function initSticky() {
    var sticky = d.querySelector('[data-lp-sticky]');
    if (!sticky) return;
    var def = sticky.querySelector('[data-lp-sticky-default]');
    var buyBar = sticky.querySelector('[data-lp-sticky-buy]');
    var totalEl = sticky.querySelector('[data-lp-sticky-total]');
    var labelEl = sticky.querySelector('[data-lp-sticky-label]');
    var baseLabel = labelEl ? labelEl.textContent : '';
    var sBtn = sticky.querySelector('[data-lp-sticky-submit]');
    var heroCta = d.querySelector('[data-lp-hero-cta] .lp-btn') || d.querySelector('[data-lp-hero-cta]') || d.querySelector('[data-lp-hero]');
    var buy = d.getElementById('buy');
    var submit = buy ? buy.querySelector('[data-o="btn"]') : null;
    var finalSec = d.querySelector('[data-lp-final]');
    var ticking = false;
    var mode = '';
    function inView(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
    function setMode(m) {
      if (m === mode) return;
      mode = m;
      sticky.classList.toggle('is-visible', m !== 'none');
      sticky.setAttribute('data-mode', m);
      if (def) def.hidden = m === 'buy';
      if (buyBar) buyBar.hidden = m !== 'buy';
    }
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      if (inView(heroCta) || inView(finalSec) || inView(submit)) { setMode('none'); return; }
      if (buy) {
        var r = buy.getBoundingClientRect();
        var inBuy = r.top < vh * 0.55 && r.bottom > vh * 0.45;
        if (inBuy) { setMode(buyBar ? 'buy' : 'none'); return; }
      }
      setMode('default');
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    d.addEventListener('lp:calc', function (e) {
      var x = e.detail || {};
      if (totalEl) totalEl.textContent = x.total ? yen(x.total) : '–';
      if (labelEl) labelEl.textContent = x.bags ? (x.color + ' ' + x.bags + '袋・送料込') : baseLabel;
      if (sBtn) sBtn.disabled = !x.ok;
    });
    if (sBtn) sBtn.addEventListener('click', function () {
      if (submit && !submit.disabled) submit.click();
      else if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    update();
  }

  /* ---------- buy / calculator ---------- */
  function yen(n) { return Math.round(n).toLocaleString('ja-JP'); }
  var ICON = {
    plus: '<svg class="lp-ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg class="lp-ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    truck: '<svg class="lp-ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6.5h11v9.5H3z"/><path d="M14 10h3.8l3.2 3.2V16h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    check: '<svg class="lp-ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>'
  };
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function initBuy() {
    var root = d.querySelector('[data-lp-buy]');
    if (!root) return;
    var dataEl = root.querySelector('[data-lp-buy-data]');
    var form = root.querySelector('[data-lp-buy-form]');
    if (!dataEl || !form) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var coverage = parseFloat(String(data.coverage).replace(',', '.')) || 1.5;
    var packs = parseInt(data.packs, 10) || 2;
    var free = parseInt(data.free, 10) || 0;
    var fee = parseInt(data.fee, 10) || 0;
    var bulk = parseInt(data.bulk, 10) || 0;

    function o(name) { return root.querySelector('[data-o="' + name + '"]'); }
    var out = { bags: o('bags'), area: o('area'), lines: o('lines'), total: o('total'), ship: o('ship'), bar: o('bar'), msg: o('msg'), btn: o('btn'), bulk: o('bulk'), carea: o('carea') };
    var custom = root.querySelector('[data-lp-custom]');
    var inW = form.querySelector('[name="lp-w"]');
    var inH = form.querySelector('[name="lp-h"]');
    var tools = form.querySelector('[name="lp-tools"]');

    if (!form.querySelector('input[name="lp-area"]:checked')) {
      var firstArea = form.querySelector('input[name="lp-area"]');
      if (firstArea) firstArea.checked = true;
    }
    if (!form.querySelector('input[name="lp-color"]:checked')) {
      var firstColor = form.querySelector('input[name="lp-color"]:not(:disabled)');
      if (firstColor) firstColor.checked = true;
    }

    function checked(name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : null; }
    function num(el) { if (!el) return 0; var n = parseFloat(String(el.value).replace(',', '.')); return isFinite(n) && n > 0 ? n : 0; }
    function find(list, color) { for (var i = 0; i < list.length; i++) if (list[i].color === color) return list[i]; return null; }

    var state = { ok: false };
    var override = null; // manual refill quantity
    var lastKey = '';
    var calcTimer = null;

    function calc() {
      var color = checked('lp-color');
      var preset = checked('lp-area');
      var hasTools = !!(tools && tools.checked);
      var isCustom = preset === 'custom';
      if (custom) custom.classList.toggle('is-active', isCustom);

      var area = 0;
      if (isCustom) {
        area = Math.round(num(inW) * num(inH) * 10) / 10;
        if (out.carea) out.carea.textContent = area ? '面積：約' + area + '㎡' : '幅と高さを入力してください';
      } else if (preset) {
        area = parseFloat(preset) || 0;
      }

      var key = [preset, isCustom ? area : '', hasTools].join('|');
      if (key !== lastKey) { override = null; lastKey = key; }

      var bags = area > 0 ? Math.max(1, Math.ceil(area / coverage - 1e-9)) : 0;
      var kitQty = hasTools ? 0 : (bags > 0 ? 1 : 0);
      var baseRefill = hasTools ? bags : Math.max(0, bags - packs);
      var minRefill = hasTools ? 1 : 0;
      var refillQty = override === null ? baseRefill : Math.max(minRefill, override);
      var kv = find(data.kit || [], color);
      var rv = find(data.refill || [], color);
      var maxRefill = rv ? rv.max : 0;

      var msg = '';
      if (!bags) msg = '';
      else if (kitQty && (!kv || !kv.available)) msg = 'この色のスターターキットは現在在庫切れです。ほかの色をお選びください。';
      else if (refillQty && (!rv || !rv.available)) msg = 'この色の追加パックは現在在庫切れです。ほかの色をお選びください。';
      else if (refillQty > maxRefill) msg = 'この色の追加パックは、一度に' + maxRefill + '袋までご注文いただけます。それ以上必要な場合はお問い合わせください。';

      var lines = '';
      var subtotal = 0;
      if (kitQty && kv) {
        subtotal += kv.price * kitQty;
        lines += '<li><div><span class="lp-line__name">' + esc(String(data.kitLine || 'スターターキット（{color}）').replace('{color}', color)) + '</span><span class="lp-line__qty">塗り壁材' + packs + '袋＋道具一式 × ' + kitQty + '</span></div><span class="lp-line__price">' + yen(kv.price * kitQty) + '円</span></li>';
      }
      if (rv && (refillQty > 0 || (!hasTools && bags > 0))) {
        subtotal += rv.price * refillQty;
        lines += '<li><div><span class="lp-line__name">' + esc(String(data.refillLine || '追加パック（{color}）').replace('{color}', color)) + '</span><span class="lp-line__qty"><span class="lp-stepper"><button type="button" data-lp-step="-1" aria-label="1袋減らす"' + (refillQty <= minRefill ? ' disabled' : '') + '>' + ICON.minus + '</button><b>' + refillQty + '</b><button type="button" data-lp-step="1" aria-label="1袋増やす"' + (refillQty >= maxRefill ? ' disabled' : '') + '>' + ICON.plus + '</button></span>袋</span></div><span class="lp-line__price">' + yen(rv.price * refillQty) + '円</span></li>';
      }

      var ship = subtotal > 0 && free && subtotal >= free ? 0 : (subtotal > 0 ? fee : 0);
      var total = subtotal + ship;
      var remain = free ? Math.max(0, free - subtotal) : 0;

      out.bags.textContent = bags ? bags : '–';
      out.area.textContent = area ? '（約' + area + '㎡）' : '';
      out.lines.innerHTML = lines;
      out.total.textContent = total ? yen(total) : '–';

      if (subtotal > 0 && free) {
        if (ship === 0) {
          out.ship.className = 'lp-result__ship is-free';
          out.ship.innerHTML = ICON.check + '<span>送料無料でお届けします</span>';
        } else {
          out.ship.className = 'lp-result__ship';
          var addBags = rv && rv.price ? Math.ceil(remain / rv.price) : 0;
          var canAdd = rv && rv.available && addBags > 0 && addBags <= 3 && refillQty + addBags <= maxRefill;
          out.ship.innerHTML = ICON.truck + '<span>送料' + yen(fee) + '円（あと' + yen(remain) + '円で送料無料）</span>' + (canAdd ? '<button type="button" data-lp-add="' + addBags + '">＋' + addBags + '袋で送料無料</button>' : '');
        }
        out.bar.style.width = Math.min(100, subtotal / free * 100) + '%';
        out.bar.parentNode.classList.toggle('is-free', ship === 0);
        out.bar.parentNode.hidden = false;
      } else {
        out.ship.className = 'lp-result__ship';
        out.ship.innerHTML = subtotal > 0 ? ICON.truck + '<span>送料' + yen(ship) + '円</span>' : '';
        out.bar.parentNode.hidden = true;
      }

      out.msg.textContent = msg;
      if (out.bulk) out.bulk.hidden = !(bulk && bags >= bulk);

      state = { ok: !msg && bags > 0 && (kitQty + refillQty) > 0, color: color, area: area, bags: bags, kitQty: kitQty, refillQty: refillQty, kv: kv, rv: rv, total: total, subtotal: subtotal };
      out.btn.disabled = !state.ok;
      try { d.dispatchEvent(new CustomEvent('lp:calc', { detail: { total: total, ok: state.ok, color: color, bags: bags } })); } catch (e) {}

      clearTimeout(calcTimer);
      calcTimer = setTimeout(function () { if (state.bags) track('lp_calc', { area: area, bags: bags, color: color, with_kit: !hasTools, value: subtotal, currency: 'JPY' }); }, 800);
    }

    form.addEventListener('change', calc);
    form.addEventListener('input', function (e) { if (e.target === inW || e.target === inH) calc(); });
    root.addEventListener('click', function (e) {
      var step = e.target.closest && e.target.closest('[data-lp-step]');
      var add = e.target.closest && e.target.closest('[data-lp-add]');
      if (step) { override = (state.refillQty || 0) + parseInt(step.getAttribute('data-lp-step'), 10); calc(); }
      if (add) { override = (state.refillQty || 0) + parseInt(add.getAttribute('data-lp-add'), 10); calc(); track('lp_upsell_free_shipping', { added: parseInt(add.getAttribute('data-lp-add'), 10) }); }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      calc();
      if (!state.ok) return;
      var items = [];
      if (state.kitQty) items.push({ id: state.kv.id, quantity: state.kitQty });
      if (state.refillQty) items.push({ id: state.rv.id, quantity: state.refillQty });
      out.btn.disabled = true;
      out.btn.classList.add('is-loading');
      out.msg.textContent = '';
      track('lp_buy', { color: state.color, area: state.area, bags: state.bags, kit_qty: state.kitQty, refill_qty: state.refillQty, value: state.subtotal, currency: 'JPY' });
      fetch(data.addUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { window.location.href = data.checkoutUrl || '/checkout'; })
        .catch(function (err) {
          out.msg.textContent = (err && (err.description || err.message)) || 'カートに追加できませんでした。時間をおいて、もう一度お試しください。';
          out.btn.disabled = false;
          out.btn.classList.remove('is-loading');
        });
    });

    calc();
  }

  ready(function () { initSticky(); initBuy(); });
})();
